import { common } from '@/service/http';
import AccessDenied from '@/views/access-denied/access-denied.vue';
import RegGrid from '@/virtual/reg-grid.vue';

export const listMetaViewsH = async () => {
  try {
    const viewsDataRes = await common('meta./meta/ui-views/get', {});
    if (viewsDataRes.result === true) {
      return viewsDataRes.data;
    }
  } catch (err) {
    console.log({ err_uuid: 'cabca41a-85fa-4409-844d-950a7f8f7ae8', err_mes: err.message });
  }
};

async function getViewMetaDef(hMeta) {
  const viewsDataRes = await common('meta./meta/ui-view-def/get', { name: hMeta.name });
  if (viewsDataRes.result === true) {
    viewsDataRes.data = { ...hMeta, ...viewsDataRes.data };
  }
  return viewsDataRes.data;
}

async function getViewMetaRegGrid(hMeta) {
  const viewsDataRes = await common('meta./meta/ui-view-reg-grid/get', { name: hMeta.name });
  if (viewsDataRes.result === true) {
    viewsDataRes.data = { ...hMeta, ...viewsDataRes.data };
  }
  return viewsDataRes.data;
}
export async function getViewMeta(viewsData, name) {
  for (const view of viewsData) {
    if (view.name === name) {
      switch (view.view_type) {
        case 'def':
          return getViewMetaDef(view);
        case 'reg_grid':
          return getViewMetaRegGrid(view);
      }
      return view;
    }
  }
  return {
    name: name,
    view_type: 'not_find',
    header: 'componentNotFind',
    text: 'componentNotFind',
    html: `<div>Component Not Find</div>`,
  };
}

function createViewDef(meta) {
  return {
    name: meta.name,
    data: function () {
      return {
        html: '',
      };
    },
    template:
      `
      <div class='ai-def'>
        ` +
      meta.html +
      `</div>`,
  };
}

function createViewRegGrid(meta) {
  return {
    name: meta.name,
    data: function () {
      return {
        name: meta.name,
        matview_schema: meta.matview_schema,
        matview: meta.matview,
        key: meta.key,
      };
    },
    components: {
      RegGrid,
    },
    template: `
      <reg-grid :viewName='name' :keyExpr='key' :dbSchema='matview_schema' :dbSource='matview' apiGetList='kv-customer-list/data/get'/>`,
  };
}

const getComponent = async (item, accessDenided) => {
  if (accessDenided && item.includes('access-denied')) {
    return AccessDenied;
  }
  const MyAsyncComponent = await loadComponent(item);
  return MyAsyncComponent;
};

const loadComponent = async item => {
  const { default: MyComponent } = await import(`@/views/${item}`);
  return MyComponent;
};

export async function createView(meta, accessDenided, ) {
  switch (meta.view_type) {
    case 'def':
      return createViewDef(meta);
    case 'reg_grid':
      return createViewRegGrid(meta);
    case 'not_find':
      return component(meta.name, accessDenided);
    // {
    //     name: meta.name,
    //     data: function() {
    //       return {
    //         name: meta.name, header: meta.header, text: meta.text, html: '',
    //       };
    //     },
    //     template: '<div>' + meta.name + '</div>',
    //   };
    default:
      return {
        name: 'not_find',
        template: `
      <div>view not find</div>`,
      };
  }
}

export function findPathByComponentName(paths, name) {
  for (const path of paths) {
    if (path.includes(`/${name}.vue`)) {
      return path;
    }
  }
}

function component(name, accessDenided) {
  const files = require.context(`@/views`, true, /.vue$/);
  const fileNames = files.keys().map(key => key.slice(2));
  const path = findPathByComponentName(fileNames, name);
  if (!path) return { name: 'not_find_' + name, template: '<' + name + '/>' };
  const existedComponent = getComponent(path, accessDenided);
  return existedComponent;
}
